function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from 'react';
import moment from 'moment-timezone';
import './day-part-select.scss';
import { getClassNames } from '../../utils/getClassNames';

var DayPartDayView = /*#__PURE__*/function (_React$Component) {
  _inherits(DayPartDayView, _React$Component);

  var _super = _createSuper(DayPartDayView);

  function DayPartDayView() {
    var _this;

    _classCallCheck(this, DayPartDayView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.handleDayClick = function (e) {
      var _this$props$onChange, _this$props;

      e === null || e === void 0 ? void 0 : e.stopPropagation();
      (_this$props$onChange = (_this$props = _this.props).onChange) === null || _this$props$onChange === void 0 ? void 0 : _this$props$onChange.call(_this$props, _this.props.day, !_this.props.value);
    };

    return _this;
  }

  _createClass(DayPartDayView, [{
    key: "render",
    value: function render() {
      var _getClassNames;

      return /*#__PURE__*/React.createElement("div", {
        className: getClassNames('day-part-day-view', (_getClassNames = {}, _defineProperty(_getClassNames, "day-".concat(this.props.day), true), _defineProperty(_getClassNames, 'mode-standard', !this.props.dayOnly), _defineProperty(_getClassNames, 'mode-day-only', this.props.dayOnly), _defineProperty(_getClassNames, 'selected', this.props.value !== false), _getClassNames))
      }, /*#__PURE__*/React.createElement("div", {
        className: "day-view-wrapper"
      }, this.props.dayOnly ? this.renderDayOnlyView() : this.renderStandardView()));
    }
  }, {
    key: "toggleSelectedValue",
    value: function toggleSelectedValue() {
      this.handleDayClick();
    }
  }, {
    key: "getFormattedDay",
    value: function getFormattedDay() {
      var _this$props$format;

      return moment().day(this.props.day).format((_this$props$format = this.props.format) !== null && _this$props$format !== void 0 ? _this$props$format : 'dd');
    }
  }, {
    key: "renderDayOnlyView",
    value: function renderDayOnlyView() {
      return /*#__PURE__*/React.createElement("div", {
        className: "day-selection day-".concat(this.props.day),
        onClick: this.handleDayClick
      }, /*#__PURE__*/React.createElement("span", null, this.getFormattedDay()));
    }
  }, {
    key: "renderStandardView",
    value: function renderStandardView() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, this.getFormattedDay(), " ", this.props.hoursEnabled.join(', ')));
    }
  }]);

  return DayPartDayView;
}(React.Component);

export var DayPartSelect = /*#__PURE__*/function (_React$Component2) {
  _inherits(DayPartSelect, _React$Component2);

  var _super2 = _createSuper(DayPartSelect);

  function DayPartSelect(props) {
    var _this2;

    _classCallCheck(this, DayPartSelect);

    _this2 = _super2.call(this, props);
    _this2._mouseEvents = {
      down: false,
      initialTargetValue: null,
      previousTarget: null
    };
    _this2.rootRef = void 0;
    _this2.dayRefs = {};

    _this2.handleDayDataChange = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(day, dayValue) {
        var _this2$props$onChange, _this2$props;

        var isMultiSelection, newValue;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isMultiSelection = _this2.props.mode !== 'single';
                newValue = _objectSpread(_objectSpread({}, _this2.currentValue), {}, _defineProperty({}, day, dayValue));

                if (!isMultiSelection) {
                  Object.keys(newValue).forEach(function (key) {
                    if (key !== day) {
                      newValue[key] = false;
                    }
                  });
                }

                _context.next = 5;
                return _this2.setState({
                  value: newValue
                });

              case 5:
                (_this2$props$onChange = (_this2$props = _this2.props).onChange) === null || _this2$props$onChange === void 0 ? void 0 : _this2$props$onChange.call(_this2$props, _this2.state.value);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();

    _this2.state = {
      value: _objectSpread(_objectSpread({}, _this2.props.defaultValue), _this2.props.value)
    };
    return _this2;
  }

  _createClass(DayPartSelect, [{
    key: "render",
    value: function render() {
      var _this3 = this,
          _getClassNames2;

      var days = this.getDayOrder();
      var _this$props2 = this.props,
          className = _this$props2.className,
          size = _this$props2.size,
          mode = _this$props2.mode,
          disabled = _this$props2.disabled;
      return /*#__PURE__*/React.createElement("div", {
        ref: function ref(el) {
          return _this3.rootRef = el;
        },
        className: getClassNames('day-part-select', className, "size-".concat(size !== null && size !== void 0 ? size : 'default'), "mode-".concat(mode !== null && mode !== void 0 ? mode : 'default'), (_getClassNames2 = {}, _defineProperty(_getClassNames2, 'disabled', disabled), _defineProperty(_getClassNames2, 'mode-standard', !this.props.daysOnly), _defineProperty(_getClassNames2, 'mode-day-only', this.props.daysOnly), _getClassNames2))
      }, /*#__PURE__*/React.createElement("div", {
        className: "day-part-select-wrapper"
      }, days.map(function (day) {
        return /*#__PURE__*/React.createElement(DayPartDayView, {
          ref: function ref(el) {
            return _this3.dayRefs[day] = el;
          },
          key: day,
          day: day,
          dayOnly: _this3.props.daysOnly,
          format: _this3.props.dayFormat,
          hoursEnabled: _this3.getHoursEnabled(day),
          onChange: _this3.handleDayDataChange,
          value: _this3.currentValue[day]
        });
      })));
    }
  }, {
    key: "currentValue",
    get: function get() {
      var defaultValue = !(this.props.mode === 'single');
      var defaultDayValues = {
        monday: defaultValue,
        tuesday: defaultValue,
        wednesday: defaultValue,
        thursday: defaultValue,
        friday: defaultValue,
        saturday: defaultValue,
        sunday: defaultValue
      };
      return _objectSpread(_objectSpread(_objectSpread({}, defaultDayValues), this.state.value), this.props.value);
    }
  }, {
    key: "getHourType",
    value: function getHourType() {
      return this.props.use24Hours ? 24 : 12;
    }
  }, {
    key: "getDayOrder",
    value: function getDayOrder() {
      var days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

      if (this.props.weekBeginsOnSunday) {
        days.unshift('sunday');
      } else {
        days.push('sunday');
      }

      return days;
    }
  }, {
    key: "getHoursEnabled",
    value: function getHoursEnabled(day) {
      var _this4 = this;

      var fullHours = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];
      var hours = fullHours;

      if (this.props.disabled !== undefined) {
        if (this.props.disabled === true) {
          hours = [];
        } else if (Array.isArray(this.props.disabled)) {
          if (this.props.disabled.includes(day)) {
            hours = [];
          }
        } else if (typeof this.props.disabled === 'function') {
          hours = fullHours.filter(function (hour) {
            return !_this4.props.disabled(hour);
          });
        } else {
          if (typeof this.props.disabled !== 'boolean') {
            var disabledDays = this.props.disabled;

            if (day in disabledDays) {
              if (Array.isArray(disabledDays[day])) {
                hours = fullHours.filter(function (hour) {
                  return !disabledDays[day].includes(hour);
                });
              } else {
                hours = fullHours.filter(function (hour) {
                  return !disabledDays[day](hour);
                });
              }
            }
          }
        }
      }

      return hours;
    }
  }]);

  return DayPartSelect;
}(React.Component);